import { render, staticRenderFns } from "./DocumentDropdown.vue?vue&type=template&id=e8a398b8&scoped=true"
import script from "./DocumentDropdown.vue?vue&type=script&lang=js"
export * from "./DocumentDropdown.vue?vue&type=script&lang=js"
import style0 from "./DocumentDropdown.vue?vue&type=style&index=0&id=e8a398b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a398b8",
  null
  
)

export default component.exports